var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4916,
    cy: 38.3511,
    r: 37.3002,
    stroke: "white",
    strokeDasharray: "3.57 3.57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.491,
    cy: 38.3511,
    r: 30.9988,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3115 29.6608C41.3115 28.0069 39.9708 26.6661 38.3168 26.6661C36.6629 26.6661 35.3222 28.0069 35.3222 29.6608V31.2203C35.3222 33.7331 33.2852 35.7701 30.7724 35.7701L29.2173 35.7701C27.5634 35.7701 26.2227 37.1109 26.2227 38.7648C26.2227 40.4187 27.5634 41.7594 29.2173 41.7594H30.7724C33.2852 41.7594 35.3222 43.7964 35.3222 46.3092V47.8686C35.3222 49.5225 36.6629 50.8633 38.3168 50.8633C39.9708 50.8633 41.3115 49.5225 41.3115 47.8686V46.3114C41.3115 43.7974 43.3495 41.7594 45.8634 41.7594H47.4251C49.079 41.7594 50.4198 40.4187 50.4198 38.7648C50.4198 37.1109 49.079 35.7701 47.4251 35.7701L45.8635 35.7701C43.3495 35.7701 41.3115 33.7321 41.3115 31.2181V29.6608Z",
    fill: "#F69A4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.4f923cbf83d911a76a44a593dfa81c9a.svg";
export { ForwardRef as ReactComponent };